import { create } from 'zustand';
import { getOtaEventsApi } from '../../../api/api';

export const useOtaEventsStore = create((set) => ({
  data: [],
  total: 0,
  isLoading: false,
  error: null,

  fetchOtaEvents: async ({ page, count, searchParams, sortBy, sortOrder } = {}) => {
    set({ isLoading: true, error: null });

    await getOtaEventsApi({
      page,
      count,
      searchParams,
      sortBy,
      sortOrder,
      dataCb: (res) => {
        set({ data: res?.items ?? [], total: res?.count ?? 0, isLoading: false });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
}));
